package com.sweetlime.dungeonamigo.repository

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.map

class FirebaseAuthRepository : AuthRepository {
    private val auth by lazy { Firebase.auth }

    override suspend fun login(email: String, password: String) {
        auth.signInWithEmailAndPassword(email, password)
    }
    override suspend fun signup(email: String, password: String) {
        auth.createUserWithEmailAndPassword(email, password)
    }
    override fun currentUserId(): String? = auth.currentUser?.uid
    override fun authStateChanged(): Flow<String?> =
        auth.authStateChanged.map { it?.uid }
    override suspend fun logout() { auth.signOut() }
    override suspend fun deleteAccount() { auth.currentUser?.delete() }
}
